import Modal from "../../../components/Modal";
import { useState, useEffect } from "react";

import { DataStore, SortDirection } from '@aws-amplify/datastore'
import { DgtPdWorkCenter } from '../../../models'
import { decodePrefixWc } from '../../../utilities/WorkCenterDecoding'

import Select from 'react-select';

const EditWorkCenter = ({ currentWorkCenter, show, onHide, division = '', orderType = '' }) => {
  const [masterWorkCenters, setMasterWorkCenters] = useState([])
  const [newWorkCenterId, setNewWorkCenterId] = useState('')
  const [isShowAll, setIsShowAll] = useState(false)

  const fetchWorkCenter = async () => {
    try {
      if (isShowAll) {
        const allWc = await DataStore.query(DgtPdWorkCenter, s => s.active("eq", true), {
          sort: s => s.id(SortDirection.ASCENDING)
        })
        setMasterWorkCenters(allWc)
        setNewWorkCenterId(allWc[0].id)
      } else {
        const prefixs = decodePrefixWc(division)
        const workCenters = await DataStore.query(DgtPdWorkCenter, 
          s => s.active("eq", true).or(c => c.id('beginsWith', prefixs[0]).id('beginsWith', prefixs[1])), {
          sort: s => s.id(SortDirection.ASCENDING)
        })
        setMasterWorkCenters(workCenters)
        setNewWorkCenterId(workCenters[0].id)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (show) {
      fetchWorkCenter()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  useEffect(() => {
    fetchWorkCenter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowAll])

  const onSelectedNewWC = (e) => {
    setNewWorkCenterId(e.value)
  }

  return <Modal
    show={show} title='เลือก Work Center ใหม่'
    cancelText='ยกเลิก'
    onHide={() => onHide(null, null)}
    okAction={() => {
      const newWc = masterWorkCenters.find(mwc => mwc.id === newWorkCenterId)
      onHide(currentWorkCenter, newWc)
    }}
    okText='ยืนยัน'>
    <Select
      className="py-3"
      menuPortalTarget={document.body}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      placeholder="เลือกจาก list หรือพิมพ์เลขเพื่อค้นหา"
      onChange={onSelectedNewWC}
      options={masterWorkCenters.map(wc => {
        return { 
          value: wc.id, 
          label: `${wc.id}-${wc.description}`
        }
      })}
      isSearchable={true}
    />
    <input
      type="checkbox"
      onChange={(e) => setIsShowAll(e.currentTarget.checked)}
      checked={isShowAll}
    />
    <label className="ml-2">แสดงทั้งหมด</label>
  </Modal>
}

export default EditWorkCenter